module.exports = __webpack_public_path__ + "app-static/img/15.5ee0a7ed.jpg";